'use client';

import useUser from '@alltrails/context/hooks/useUser';
import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

const GenericPostAuthUpsellModal = dynamic(() => import('@alltrails/upsell/components/GenericPostAuthUpsell/PostAuthUpsellModal'), {
  ssr: false
});

/*
  AppleRedirectUpsell displays the post-auth upsell to non-plus users who authenticated with Apple.
  For Apple auth, the user is taken to a separate page, then redirected back to our site.
  When a user returns, the apple_oauth param is included in search params.
 */

const AppleRedirectUpsell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useUser();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const isInUpsellTier = user?.subscriptionTier !== 'peak';
    if (searchParams.has('apple_oauth') && user && isInUpsellTier) {
      setIsOpen(true);
    }
  }, [user]);

  return (
    <>{isOpen && <GenericPostAuthUpsellModal isOpen={isOpen} onCloseRequest={() => setIsOpen(false)} upsellTrigger="Complete Authentication" />}</>
  );
};

export default AppleRedirectUpsell;
